<template>
<div id="login">
  <!-- <div class="container">
      <FlashMessage :position="'right top'"/>
    <div class="title display-3">Owner register</div>
    <form>
      <div>
        <div class="form-group">
        
          <input
            type="email"
            class="form-control"
            placeholder="Enter your email"
            v-model="email"
          />
        </div>

        <div class="form-group">
        
          <input
            type="password"
            class="form-control"
            placeholder="Enter your password"
            v-model="password"
          />
        </div>
      </div>
      <button class="btn btn-block" v-on:click.prevent="posting">submit</button>
    </form>
  </div> -->

  <div class="mx-auto login-form">
       <FlashMessage :position="'right top'" />
        <form>
            <h2 class="text-center">Owner Register</h2>       
            <div class="form-group">
                <input type="text" class="form-control" placeholder="Email Address" v-model="email" required="required">
            </div>
            <div class="form-group">
                <input type="password" class="form-control" placeholder="Password" v-model="password" required="required">
            </div>
            <div class="form-group">
                <button type="submit" v-on:click.prevent="posting" class="btn btn-primary btn-block">Register</button>
            </div>
                 
        </form>
    </div>


  </div>
</template>

<script>
//import {fb} from "../firebase";
import axios from 'axios'
export default {
  data() {
    return {
      email: "",
      password: "",
    };
  },

  methods: {
    posting: function () {

    if(this.password.length>=6 && this.password!="")
      {
      axios.post('https://pg-v1.herokuapp.com/signup',{
        email:this.email,
        password:this.password
      })
      .then(res=>{
        console.log(res)

           
        this.flashMessage.setStrategy('single');
        this.flashMessage.success({
        message: res.data.message,
        time: 5000,
        blockClass: 'custom-block-class'
        });

       setTimeout(this.$router.push('ownerlogin'),3000)

        })
      .catch(err=>{
        console.log(err.response)
        
        this.flashMessage.setStrategy('single');
        this.flashMessage.error({
        message: err.response.data.message,
        time: 3000,
        blockClass: 'custom-block-class'
        });
        })
      }
    else{
         this.flashMessage.setStrategy('single');
        this.flashMessage.error({
        message: 'password must be more than 6 characters',
        time: 3000,
        blockClass: 'custom-block-class'
        })  
    }
    },
  },



};
</script>


<style  src='../assets/css/login.css' scoped> </style>

<style scoped>

#login{
    background-color: rgb(66,66,66);
    min-height: 100vh;
}

.title{
  color:aliceblue;
  font-size: 3em;
}


</style>